var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"barcodeReaderArticle"}},[_c('section',{staticClass:"sectionRederArticle"},[_c('v-quagga',{attrs:{"onDetected":_vm.logIt,"readerTypes":['code_128_reader']}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }